module.exports = __webpack_public_path__ + "img/phone_head.b56571fe.png";